import { Tag } from "bbcode-to-react";
import * as React from "react";
class BrTag extends Tag {
    toHTML() {
        return ["<br />"];
    }
    toReact() {
        return React.createElement("br", null);
    }
}
export default BrTag;
